import Header from "@/components/Header"
import { useUser } from "@/hooks/useUser"
import { Navigate, Outlet } from "react-router-dom"

export default function WawancaraTalentscoutingLayout() {
  const { user, isPending } = useUser()
  const userRoles = user?.jenis_user || []
  const wawancaraTalentscouting = userRoles.includes("wawancara_talent")

  if (!isPending && !wawancaraTalentscouting) return <Navigate to={"/"} />

  return (
    <main className="flex">
      <section className="flex-1 overflow-x-auto p-5 min-h-screen">
        <Header />
        <Outlet />
      </section>
    </main>
  )
}
